import React from "react";
import { formatQuantity } from "./utils";

// Convert ingredient quantities into numbers
const parseQuantity = (quantity) => {
  if (quantity === null || quantity === undefined) {
    return null;
  }

  const value = String(quantity).trim();

  if (!isNaN(Number(value))) {
    return Number(value);
  }

  // Mixed fractions
  if (value.includes(" ")) {
    const [whole, fraction] = value.split(" ");
    const [numerator, denominator] = fraction.split("/").map(Number);

    if (
      !isNaN(Number(whole)) &&
      !isNaN(numerator) &&
      !isNaN(denominator) &&
      denominator !== 0
    ) {
      return Number(whole) + numerator / denominator;
    }
  }

  // Simple fractions
  if (value.includes("/")) {
    const [numerator, denominator] = value.split("/").map(Number);

    if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
      return numerator / denominator;
    }
  }

  // Quantity isn't numeric, so don't scale it
  return null;
};

const RecipeIngredients = ({ ingredient, servings, originalServings }) => {
  // Calculate how much the ingredient quantities need to change
  const servingMultiplier =
    servings && originalServings ? servings / originalServings : 1;

  // Convert fraction string to Unicode character, or use original if not found
  const originalQuantity = parseQuantity(ingredient.quantity);
  const adjustedQuantity =
    originalQuantity !== null
      ? Number((originalQuantity * servingMultiplier).toFixed(2))
      : ingredient.quantity;

  const displayAmount = formatQuantity(adjustedQuantity);
  return (
    <div className="Row Medium-Font">
      <p>-</p>
      <span className="marg-0 marg-left-5">
        {displayAmount} {ingredient.measurement}{" "}
        {ingredient.amazonLink ? (
          <a href={ingredient.amazonLink}>{ingredient.name}</a>
        ) : (
          ingredient.name
        )}
      </span>
    </div>
  );
};

export default RecipeIngredients;